import React from 'react';
import { Button, Card, CardBody, Col, Modal } from 'reactstrap';
import CloseButton from "@/shared/components/CloseButton";
import { RUN_STATUS } from '../invoicingCycleApi';

const CycleCounts = ({ title, staged, charged, invoiced }) => (
  <div className='mb-3'>
    <strong>{title}</strong>
    <div>Programs staged: {staged}</div>
    <div>Charges posted: {charged}</div>
    <div>Invoices created: {invoiced}</div>
  </div>
);

const FailedRun = ({ run }) => (
  <>
    <div className='mb-3'>Run #{run.id} did not complete.</div>
    <div className='mb-3' style={{ color: '#c88' }}>{run.error}</div>
    <div className='mb-3' style={{ color: '#a5a5a5' }}>
      Part of the cycle may already have been billed. Running the same period again
      finishes what is left rather than billing it twice.
    </div>
  </>
);

const RunningRun = ({ run }) => (
  <>
    <div className='mb-3'>Run #{run?.id} is working through both cycles.</div>
    <div className='mb-3' style={{ color: '#a5a5a5' }}>
      This takes a few minutes. It runs on the server, so you can close this and come back -
      the result is kept against the run.
    </div>
  </>
);

const FinishedRun = ({ run }) => (
  <>
    <div className='mb-3'>Billing period starting {run.period_start}</div>
    <CycleCounts
      title='Pay in arrears'
      staged={run.arrears_programs_staged}
      charged={run.arrears_charges_posted}
      invoiced={run.arrears_invoices_created}
    />
    <CycleCounts
      title='Advance pay'
      staged={run.advance_pay_programs_staged}
      charged={run.advance_pay_charges_posted}
      invoiced={run.advance_pay_invoices_created}
    />
    <div className='mb-3' style={{ color: '#a5a5a5' }}>
      Zeros mean the period was already invoiced, not that nothing happened.
    </div>
  </>
);

const RunBody = ({ run }) => {
  if (run?.status === RUN_STATUS.FAILED) {
    return <FailedRun run={run} />;
  }

  if (run?.status !== RUN_STATUS.FINISHED) {
    return <RunningRun run={run} />;
  }

  return <FinishedRun run={run} />;
};

const InvoicingCycleRunResult = ({ isOpen, toggle, run }) => {

  return (
    <Modal className={`modal-lg modal-md p-0`} isOpen={isOpen} toggle={toggle}>
      <CloseButton onClick={toggle} />
      <Card className='w-100'>
        <CardBody className='text-left'>
          <div className='w100'>
            <Col md="12" lg="12" xl="12">
              <div className="card__title">
                <h5 className="colorgrey">Invoicing cycle run</h5>
              </div>
            </Col>
          </div>
          <div className='w100'>
            <Col md="12" lg="12" xl="12">
              <div className='mt-3'>
                <RunBody run={run} />
                <Button color='primary' type='submit' onClick={toggle}>Ok</Button>
              </div>
            </Col>
          </div>
        </CardBody>
      </Card>
    </Modal>
  )
}

export default InvoicingCycleRunResult;
